import { client } from '../client';
import { Insurance } from './types/UserProfile';

export const getPatientInsurance = async (user_id?: number): Promise<Insurance[]> => {
  const { data } = await client.get<Insurance[]>(`/insurances${user_id ? `?user_id=${user_id}` : ''}`);

  return data;
};
